import './Services.css';
import Navbar from '../Navbar/Navbar'; 

import service02 from '../../assets/img/services/services-02.png';
import service03 from '../../assets/img/services/services-03.png';
import service04 from '../../assets/img/services/services-04.png';
import service05 from '../../assets/img/services/services-05.png';
import service06 from '../../assets/img/services/services-06.png';
import service07 from '../../assets/img/services/services-07.png';
import service08 from '../../assets/img/services/services-08.png';
import service09 from '../../assets/img/services/services-09.png';
import service10 from '../../assets/img/services/services-10.png';
import service11 from '../../assets/img/services/services-11.png';
import service12 from '../../assets/img/services/services-12.png';
import service13 from '../../assets/img/services/services-13.png';
import service14 from '../../assets/img/services/services-14.png';
import service15 from '../../assets/img/services/services-15.png';
import service16 from '../../assets/img/services/services-16.png';
import service17 from '../../assets/img/services/services-17.png';
import Footer from '../Footer/Footer';



const Services = () => {
 
    return (
        <>
        <div className="main-wrapper">
             <header class="header">
                <Navbar />
            </header>

            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Services</li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">Services</h2>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container">
                    <section className="hero-section">
                        <h2>Our Comprehensive Healthcare Services</h2>
                        <p>At Hitkari Hospital, we are committed to offering a comprehensive range of medical services that prioritize health, comfort, and care.</p>
                    </section>

                    <div className="service-section fade-in">
                        <div className="content-area">
                            <p>We believe in delivering more than just medical treatment – we deliver a holistic approach to wellness that takes into account your emotional, physical, and mental health. Whether you are seeking routine care or advanced treatment, our team of experts is dedicated to providing you with the best healthcare experience in the region.</p>
                            <p>Our state-of-the-art facilities, coupled with cutting-edge technology and a compassionate approach, ensure that your health is always our top priority. Explore our wide range of services designed to care for you and your loved ones.</p>
                        </div>
                    </div>

                    <div className="service-section fade-in">
                        <div className="content-area">
                        <a href='/internal'>  <h3>1. General Medicine</h3></a>
                            <p>Our General Medicine department provides a comprehensive approach to health, offering preventive care,
                                diagnosis, and treatment for various medical conditions. From routine check-ups to complex medical
                                conditions, we ensure your well-being with personalized care from our expert team of physicians.</p>
                        </div>
                        <div className="image-container">
                            <img src={service02} alt="General medicine" />
                        </div>
                    </div>
                    <div className="service-section fade-in">
                        <div className="content-area">
                            <h3>2. General Surgery</h3>
                            <p>Our General Surgery department is equipped with the latest surgical tools and technologies. We offer
                                both minor and major surgeries, with an emphasis on precision and patient comfort. Whether you
                                require an urgent procedure or a scheduled surgery, our surgeons ensure the highest standards of
                                safety and care.</p>
                        </div>
                        <div className="image-container">
                            <img src={service04} alt="General surgery" />
                        </div>
                    </div>
                    <div className="service-section fade-in">
                        <div className="content-area">
                        <a href='/lap'>    <h3>3. Laparoscopic Surgery</h3></a>
                            <p>At Hitkari Hospital, we specialize in Laparoscopic Surgery, which uses minimally invasive
                                techniques to provide quicker recovery times and reduced discomfort. Our advanced laparoscopy
                                procedures, such as gallbladder removal and appendicitis surgery, promote healing while minimizing
                                recovery time.</p>
                        </div>
                        <div className="image-container">
                            <img src={service03} alt="Laparoscopic surgery" />
                        </div>
                    </div>
                  <div className="service-section fade-in">
                   <div className="content-area">
                   <a href='/orthopedic'>  <h3>4. Orthopaedic Surgery</h3>  </a>
                            <p>Our Orthopaedic Surgery team provides advanced care for bone, joint, and muscle issues. Whether you
                                need a joint replacement, fracture repair, or specialized spinal surgery, we combine advanced
                                techniques with personalized care to restore your mobility and quality of life.</p>
                        </div>
                        <div className="image-container">
                            <img src={service05} alt="Orthopaedic surgery" />
                        </div>
                  
                    </div>

                  <div className="service-section fade-in">
               <div className="content-area">
               <a href='/urology'> <h3>5. Urology</h3></a>
                            <p>The Urology department at Hitkari Hospital specializes in the diagnosis and treatment of urinary
                                system issues. From kidney stones to bladder conditions, our experts provide comprehensive care,
                                including non-invasive treatments and surgical interventions to ensure your health and comfort.</p>
                        </div> 
                        <div className="image-container">
                            <img src={service06} alt="Urology" />
                        </div>
                   
                    </div>
                    <div className="service-section fade-in">
                        <div className="content-area">
                        <a href='/ped'>    <h3>6. Paediatric Surgery</h3></a>
                            <p>We offer specialized Paediatric Surgery for children, ranging from routine procedures to complex
                                surgeries. With a compassionate approach, our pediatric surgeons ensure the comfort and safety of
                                your little ones, providing expert care in a child-friendly environment.</p>
                        </div>
                        <div className="image-container">
                            <img src={service07} alt="Paediatric surgery" />
                        </div>
                    </div>

                    <div className="service-section fade-in">
                        <div className="content-area">
                        <a href='/women'>   <h3>7. Neonatology</h3></a>
                            <p>Our Neonatology department provides the highest level of care for newborns, especially premature or
                                critically ill infants. With our state-of-the-art NICU and life-saving technologies, we ensure the
                                best possible start to life for your baby.</p>
                        </div>
                        <div className="image-container">
                            <img src={service08} alt="Neonatology" />
                        </div>
                    </div>
                    <div className="service-section fade-in">
                        <div className="content-area">
                            <h3>8. Obstetrics and Gynaecology</h3>
                            <p>Our Obstetrics and Gynaecology team offers expert care for women throughout every stage of life. From
                                pre-conception care to gynecological surgery and maternal care, we provide compassionate and
                                comprehensive services designed for your well-being and health.</p>
                        </div>
                        <div className="image-container">
                            <img src={service09} alt="Obstetrics and Gynaecology" />
                        </div>
                    </div>
                    <div className="service-section fade-in">
                        <div className="content-area">
                        <a href='/psy'>    <h3>9. Psychiatry</h3></a>
                            <p>Our Psychiatry Department provides specialized care for individuals facing mental health challenges,
                                such as anxiety, depression, and bipolar disorders. We focus on compassionate care, offering
                                individual therapy, medication management, and support groups to help you navigate mental health with
                                confidence.</p>
                        </div>
                        <div className="image-container">
                            <img src={service10} alt="Psychiatry" />
                        </div>
                    </div>
                    <div className="service-section fade-in">
                        <div className="content-area">
                            <h3>10. Pain Management</h3>
                            <p>At Hitkari Hospital, our Pain Management Hospital offer advanced treatments designed to help patients
                                suffering from chronic pain. Whether you are dealing with musculoskeletal pain, neurological pain, or
                                post-surgery discomfort, our specialists will work with you to create a personalized care plan that
                                targets the root cause of your pain.</p>
                        </div>
                        <div className="image-container">
                            <img src={service11} alt="Pain Management" />
                        </div>
                    </div>
                    <div className="service-section fade-in">
                        <div className="content-area">
                            <h3>11. Rheumatology</h3>
                            <p>Our Rheumatology department provides advanced treatment for autoimmune disorders and joint diseases,
                                such as rheumatoid arthritis, lupus, and gout. Using the latest research and treatments, we aim to
                                improve mobility, reduce pain, and prevent long-term damage to joints and tissues.</p>
                        </div>
                        <div className="image-container">
                            <img src={service12} alt="Rheumatology" />
                        </div>
                    </div>
                    <div className="service-section fade-in">
                        <div className="content-area">
                        <a href='/skin'> <h3>12. Dermatology</h3></a>    
                            <p>We offer comprehensive Dermatology services for a range of skin conditions, from acne to psoriasis, and
                                skin cancer treatment. Our dermatologists use both medical and cosmetic dermatology techniques to
                                address skin issues, ensuring you leave with healthy, radiant skin.</p>
                        </div>
                        <div className="image-container">
                            <img src={service13} alt="Dermatology" />
                        </div>
                    </div>
                    <div className="service-section fade-in">
                        <div className="content-area">
                            <h3>13. Biochemistry, Pathology & Microbiology</h3>
                            <p>Our Laboratory Services (Biochemistry, Pathology, and Microbiology) provide accurate, timely, and
                                reliable diagnostic testing. With the latest automated analyzers and diagnostic techniques, we support
                                our medical team in providing precise diagnosis and effective treatment plans.</p>
                        </div>
                        <div className="image-container">
                            <img src={service14} alt="Biochemistry, Pathology & Microbiology" />
                        </div>
                    </div>
                    <div className="service-section fade-in">
                        <div className="content-area">
                            <h3>14. Radiology and Imaging</h3>
                            <p>Our Radiology department features the latest imaging technologies, including CT scans, MRI, X-rays, and
                                ultrasound. These tools enable our doctors to make accurate diagnoses, creating the foundation for
                                an effective treatment plan tailored to your needs.</p>
                        </div>
                        <div className="image-container">
                            <img src={service15} alt="Radiology and Imaging" />
                        </div>
                    </div>
                    <div className="service-section fade-in">
                        <div className="content-area">
                        <a href='/phy'> <h3>15. Physical Medicine and Rehabilitation</h3></a>
                            <p>Our Physical Medicine and Rehabilitation services are designed to help you recover from surgery,
                                injury, or chronic conditions. Through personalized therapy programs, our team focuses on improving
                                mobility, strength, and independence, enabling you to regain full functionality.</p>
                        </div>
                        <div className="image-container">
                            <img src={service16} alt="Physical Medicine and Rehabilitation" />
                        </div>
                    </div>
                    <div className="service-section fade-in">
                        <div className="content-area">
                            <h3>16. 24/7 Emergency Services</h3>
                            <p>Accidents and health emergencies can happen at any time. Our 24/7 Emergency Services are ready to
                                handle any crisis, from heart attacks to accidents. With immediate access to advanced medical care,
                                our team ensures that your health is in safe hands during emergencies.</p>
                        </div>
                        <div className="image-container">
                            <img src={service17} alt="24/7 Emergency Services" />
                        </div>
                    </div>
                    <div className="service-section fade-in why-choose-section">
                        <h3>Why Choose Hitkari Hospital?</h3>
                        <ul>
                            <li><strong>Highly Skilled Doctors:</strong> Our team of specialists is experienced in treating complex
                                medical conditions, ensuring that you receive the best care possible.</li>
                            <li><strong>State-of-the-Art Technology:</strong> We integrate the latest medical equipment and technology,
                                ensuring advanced treatments and the best outcomes for patients.</li>
                            <li><strong>Patient-Centered Care:</strong> We believe in providing care that goes beyond treating the
                                disease. We treat each patient with dignity, respect, and empathy.</li>
                            <li><strong>Affordable Healthcare:</strong> We offer high-quality healthcare at reasonable rates,
                                ensuring that medical treatment is accessible to all, regardless of financial background.</li>
                            <li><strong>Comprehensive Medical Care:</strong> From diagnosis to recovery, we provide a full range of
                                services to meet every aspect of your health.</li>
                        </ul>
                    </div>
                     <div className="service-section fade-in">
                         <p>At Hitkari Hospital, we are more than just a healthcare facility. We are a community of compassionate
                             professionals dedicated to improving your life. We believe in providing care that is both advanced
                            and compassionate, ensuring that your health is always in the best hands. Your health is our
                             priority — every patient, every time.</p>
                     </div>
                </div>
            </div>
        </div>
        <Footer/>
        </>
    );
};

export default Services;